type MedusaBackendUrlOptions = {
  isServer: boolean
  internalUrl?: string | null
  publicUrl?: string | null
}

const normalized = (value?: string | null) => value?.trim().replace(/\/$/, "") || ""

export function resolveMedusaBackendUrl({
  isServer,
  internalUrl,
  publicUrl,
}: MedusaBackendUrlOptions) {
  const internal = normalized(internalUrl)
  const publicBackend = normalized(publicUrl)

  if (isServer && internal) return internal
  if (publicBackend) return publicBackend
  return "http://localhost:9000"
}
